import { Instance, flow, types } from 'mobx-state-tree';

import { UserActionTypes, commitAction } from '@common/api/users';

const ConsultationProfileModel = types
	.model('ConsultationProfileModel', {
		package_id: types.number,
		total_duration: types.number,
		left_duration: types.number,
		last_start_dt_90: types.maybeNull(types.string),
		opened_consultation_link: types.maybeNull(types.boolean),
	})
	.volatile(() => ({
		loading: false,
	}))
	.actions((self) => ({
		updateConsultationUserAction: flow(function* (): Generator<any, void, any> {
			try {
				self.loading = true;
				yield commitAction({ actionType: UserActionTypes.OpenedConsultationLink });
			} finally {
				self.loading = false;
			}
		}),
	}));

export default ConsultationProfileModel;

export type IConsultationProfileModel = Instance<typeof ConsultationProfileModel>;
